// LoginPage.js
import React, { useState, useEffect } from 'react';
import { Button, Row, Col, Typography } from 'antd';
import '../CSSfiles/LoginPage.css'; // Import custom CSS file for styling
import logo from '../images/talent-icon.png'; // Import custom image
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { useNavigate } from 'react-router-dom';
import { fetchData } from "../fetch";
import { useAppContext } from './AppContext';
import apteanLogo from '../images/Aptean Logo - Black.svg';
import { set } from 'date-fns';
import { employeesURL } from '../Config';

const { Text } = Typography;

const LoginPage = () => {
  const [graphData, setGraphData] = useState(null);
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();
  const { upName, setUpName, mailID, setMailID, setAccessToken, setIsAdmin,setIdToken } = useAppContext();

  useEffect(() => {
    if (isAuthenticated) {
      fetchGraphData();
    }
  }, [isAuthenticated]);

  const fetchGraphData = async () => {
    try {
      //console.log("Fetching Graph Data");

      const account = instance.getActiveAccount();
      const silentRequest = {
        scopes: ["User.Read", "User.Read.All"],
        account: account,
        forceRefresh: false // Set to true to skip cache lookup
      };

      const response = await instance.acquireTokenSilent(silentRequest);

      //console.log("response", response);
      //console.log("Access Token: ", response.accessToken);
      //console.log("idtoken", response.idToken);

      await processTokenResponse(response);

    } catch (error) {
      //console.error('Error acquiring token silently:', error);
      
      // Check if error is due to timeout or interaction required
      if (error.name === 'BrowserAuthError' || 
          error.message.includes('monitor_window_timeout') ||
          error.message.includes('interaction_required')) {
        
        try {
          // Fallback to interactive token acquisition
          const response = await instance.acquireTokenPopup({
            scopes: ["User.Read", "User.Read.All"]
          });
          
          await processTokenResponse(response);
          
        } catch (popupError) {
          console.error('Error acquiring token with popup:', popupError);
          // If popup also fails, redirect to login
          handleSSOLogin();
        }
      } else {
        console.error('Unexpected error during token acquisition:', error);
      }
    }
  };

  const processTokenResponse = async (response) => {
    // Check for roles in the ID token
    const roles = response.idTokenClaims.roles || [];
    //console.log("Roles", roles);

    if (roles.includes("User.Admin") || roles.includes("User.General")) {
      //console.log("User has required roles");
      if (roles.includes("User.Admin")) {
        setIsAdmin(true);
      } else {
        setIsAdmin(false);
      }

      setAccessToken(response.accessToken);
      setIdToken(response.idToken);
      //console.log("Access Token from context: ", response.accessToken);

      const graphResponse = await fetchData("https://graph.microsoft.com/v1.0/me", response.accessToken);
      const data = await graphResponse.json();

      setGraphData(data);
      setMailID(data.mail);
      setUpName(data.userPrincipalName);

      //Once SSO is successful, check if the user exists in the backend database
      const isAuthorizedUser = await checkEmployeeData(data.userPrincipalName, response.idToken);
      if (!isAuthorizedUser) {
        // If user does not exist, navigate to Unauthorized page
        navigate('/unauthorized');
        return;
      }

      navigate('/home');
    } else {
      //console.log("User does not have required roles");
      navigate('/unauthorized');
    }
  };

  // Function to handle SSO login
  const handleSSOLogin = () => {
    //console.log("SSO login button clicked");
    //console.log("User is authenticated: ", isAuthenticated);
    //console.log("Instance: ", instance);

    if (!isAuthenticated) {
      instance.loginRedirect({
        scopes: ['User.Read', 'User.Read.All']
      });
    }
  };

  const checkEmployeeData = async (userPrincipalName, idToken) => {
    try {
      const response = await fetch(employeesURL + `/check-authorized-user/${userPrincipalName}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${idToken}`
          }
        });
        if (!response.ok) {
          throw new Error('Failed to fetch data');
        }
        
        const data = await response.json();
        return data; // Assuming the API returns { isAuthorized: true/false }
    } catch (error) {
      console.error("Error fetching employee data:", error);
      return false;
    }
  }

  return (
    <>
      {!isAuthenticated ? (
        <Row>
          {/* Left Half */}
          <Col span={12}>
            <div style={{ height: '133.3vh', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', margin: 0, padding: 0 }}>
              <img src={logo} alt="Left Half Image" style={{ minWidth: '100%', minHeight: '100%', objectFit: 'cover', margin: 0, padding: 0 }} />
            </div>
          </Col>

          {/* Right Half */}
          <Col span={12}>
            <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
              <img src={apteanLogo} alt="Logo" style={{ maxWidth: '25%', marginBottom: '30px' }} />
              <br />
              <br />
              <br />
              <br />
              <br />
              <Text style={{ fontSize: '30px' }}>Aptean Talent Review</Text>
              <br />
              <br />
              <Button style={{ width: '25%', height: '50px', fontSize: '20px', backgroundColor: 'black', color: 'white' }} onClick={handleSSOLogin}>
                Company Single Sign-On
              </Button>
            </div>
          </Col>
        </Row>
      ) : null}
    </>
  );
};

export default LoginPage;
